import { useEffect, useState } from 'react';

import { ScrollSmoother } from '@/lib/gsap';

export const useSmootherReady = () => {
	const [smoother, setSmoother] = useState<ScrollSmoother | null>(null);

	useEffect(() => {
		const id = setInterval(() => {
			const inst = ScrollSmoother.get();

			if (inst) {
				clearInterval(id);
				setSmoother(inst);
			}
		}, 50);

		return () => clearInterval(id);
	}, []);

	return smoother;
};
